/**
 * Cookiebot
 * https://wordpress.org/plugins/cookiebot/
 * https://support.cookiebot.com/hc/en-us/articles/360016047000-Cookiebot-and-Google-Consent-Mode
 */
export const cookiebot = {

	/**
	 * Get the Cookiebot cookie.
	 *
	 * @returns {{statistics: boolean, marketing: boolean, preferences: boolean, necessary: boolean}|null}
	 */
	getConsent: () => {

		// let consent = "{stamp:%27z5ZnyohzGbbYMhDdKsdXYMG3VT5a4l7mPBcyMeFe8vasPesmw/X1sQ==%27%2Cnecessary:true%2Cpreferences:true%2Cstatistics:false%2Cmarketing:true%2Cmethod:%27explicit%27%2Cver:1%2Cutc:1712435323862%2Cregion:%27ch%27}"
		let consent = pmw.getCookie("CookieConsent")

		if (!consent) return null

		/**
		 * Cookiebot writes "-1" for a visitor in a region where its configuration
		 * asks for no consent. Cookiebot itself treats that as everything allowed.
		 * It parses as valid JSON, so it has to be caught before the object path,
		 * which would otherwise find no category at all.
		 */
		if (consent.replace(/['"]/g, "").trim() === "-1") {

			pmw.console.log("Cookiebot CMP consent detected (consent not required in this region)")

			return {
				statistics : true,
				marketing  : true,
				preferences: true,
				necessary  : true,
			}
		}

		consent = consentToJson(consent)

		if (!consent) {
			pmw.console.log("Cookiebot cookie could not be parsed. Ignoring it.")
			return null
		}

		/**
		 * A cookie that names no category carries no visitor decision. Reading one
		 * as consent would unblock every pixel before the visitor has answered the
		 * banner. Sibling of the Cookie Script guard in cookie-script.mjs and the
		 * Complianz guard in complianz.mjs.
		 */
		if (!["necessary", "preferences", "statistics", "marketing"].some(category => category in consent)) {
			pmw.console.log("Cookiebot cookie detected, but it carries no consent categories. Ignoring it.")
			return null
		}

		pmw.console.log("Cookiebot CMP consent detected")

		/**
		 * A category the cookie does not name is denied. Cookiebot's own JS API
		 * documents the same defaults, and granting an unknown is what the deny by
		 * default policy forbids. Same change as the iubenda reader in 1.58.10.
		 */
		return {
			statistics : consent.statistics ?? false,
			marketing  : consent.marketing ?? false,
			preferences: consent.preferences ?? false,
			necessary  : consent.necessary ?? true,
		}
	},

	/**
	 * Cookiebot
	 * 	If visitor accepts cookies in Cookiebot unblock the scripts
	 *
	 * 	Cookiebot requires the events to be attached to the window object not the document object
	 *
	 * 	https://www.cookiebot.com/en/developer/
	 */
	loadEventListeners: () => {

		window.addEventListener("CookiebotOnAccept", (e) => {

			const consent = e.currentTarget?.CookieConsent?.consent ?? {}

			let data = {
				statistics : consent.statistics ?? false,
				marketing  : consent.marketing ?? false,
				preferences: consent.preferences ?? false,
				necessary  : consent.necessary ?? true,
			}

			pmw.consent.api.updateSelectively({...data, source: "cmp"})
		}, true)
	},
}

/**
 * Parse the CookieConsent cookie.
 *
 * Cookiebot writes it either as JSON or as a JavaScript object literal with
 * single quoted values, in both cases URI encoded.
 *
 * @param consent {string}
 * @returns {Object|null} - null when the cookie cannot be parsed
 */
const consentToJson = (consent) => {

	try {

		let parsed

		if (isValidJson(consent)) {
			parsed = JSON.parse(consent)
		} else {
			consent = decodeURI(consent)
			consent = consent.replace(/'/g, "\"") // Replace single quotes with double quotes as JSON requires double quotes
			consent = decodeURIComponent(consent)
			consent = consent.replace(/(\w+):/g, "\"$1\":") // Add double quotes to keys
			parsed  = JSON.parse(consent)
		}

		// A cookie holding a bare number or string parses fine but has no
		// categories to read, and the `in` check on it would throw.
		if (typeof parsed !== "object" || parsed === null) return null

		return parsed

	} catch (e) {
		return null
	}
}

const isValidJson = (str) => {
	try {
		JSON.parse(str)
	} catch (e) {
		return false
	}
	return true
}
